import * as _ from "lodash";
import {BigNumber} from "bignumber.js";

// 订单类别(project_type)：1普通、2全案营销、3普客、4年框大全案、5纯直播
export const PT_PT = 1;
export const PT_QA = 2;
export const PT_PK = 3;
export const PT_NK = 4;
export const PT_CZB = 5;
export const pyTypeMap = {
  PT_PT: '普通订单',
  PT_QA: '全案营销',
  PT_PK: '普客打包',
  PT_NK: '年框大全案',
  PT_CZB: '纯直播',
};

/* eslint-disable */
/**
 * ### 自定义toFixed
 * 解决 toFixed 返回结果不固定为四舍五入
 *
 * @param {Number} number 需要处理但数字
 * @param {Number} index 截取多少位
 */

function mTofixed(number, index) {
  // console.log("mtofixed", number,index);
  try {
    let over = _.round(number, index)
    // let _over = over.toString().split('.')
    // if(_over[1] & _over[1].split('')[index + 1]){

    // }


    return over
    // let _number = isNaN(number) ? '0' : String(number)
    // if(!_number) {
    //     let over = new Array(index).fill(0)
    //     return '0' + '.'+ over.join('')
    // }
    // let _trage = _number.split('.')

    // if (_trage.length > 1) {
    //     let _decimal = _trage[1].split('')
    //     if (_decimal.length > index) {
    //         let over = 0
    //         if(_decimal[index] >= 5) {
    //             // _decimal[index - 1] = String(Number(_decimal[index - 1]) + 1)
    //             let _num = Number(_trage[0] + '.'+ _decimal.splice(0, index).join(''))
    //             let _plus = (0.1 / Math.pow(10,index - 1))
    //             over = Number(Number(_num + _plus).toFixed(index))
    //         } else {
    //             over = Number(_trage[0] + '.'+ _decimal.splice(0, index).join(''))
    //         }
    //         return  over
    //     } else {
    //         return _number
    //     }
    // } else {
    //     let over = new Array(index).fill(0)
    //     return _trage[0] + '.'+ over.join('')
    // }

  } catch (error) {
    console.error(error);
  }


}

/**
 * 判断订单
 * ① 是不是全案营销订单
 * ② main 是不是全案营销主单
 * ③ child 是不是全案营销子单
 * @param row
 * @param code
 * @returns {boolean}
 */
function judgeOrderWholeCase(row, code = 'is_mark') {
  let bool = false;

  switch (code) {
    case 'is_mark':
      // 全案营销
      if (row.is_mark) {
        bool = true
      }
      break;
    case 'child':
      // 全案营销子单
      if (row.is_mark && row.pid !== 0) {
        bool = true
      }
      break;
    case 'main':
      // 全案营销主单
      if (row.is_mark && row.pid === 0) {
        bool = true
      }
      break;
  }
  return bool
}


/**
 * 过滤查询条件
 * @param data
 * @returns {{}}
 */
function filterSearchCondition(data) {
  let condition = {}

  //多选： wherein的条件 9个
  condition.multiple = {}
  let multipleFields = ['customer_id', 'artist_id', 'bool_exec', 'order_source', 'executor_id', 'pay_status', 'invoice_status', 'sale_id', 'platform', 'is_lb', 'is_trailer', 'order_no', 'organization_id', 'oth_order_no', 'exec_customer_id']
  multipleFields.forEach((field) => {
    if (data[field] && data[field].length > 0) {
      condition.multiple[field] = data[field]
    }
  })

  //时间类型选择，解析其时间 3个
  if (data.time_type) {
    if (data.timeRange) {
      condition.time_type = data.time_type
      condition.begin_timestamp = data.timeRange[0]
      condition.end_timestamp = data.timeRange[1]
    }
  }
  //其他：单选字段 8个
  let singleFields = ['brand', 'agent_name', 'order_type', 'bool_undo', 'is_new_customer', 'form_of_cooperation', 'contract_filed', 'contract_no', 'company_id', 'activation_type', 'is_mark_invoiced', 'is_mark_rebate', 'is_can_invoice', 'by_the_user', 'bool_covenant', 'invoice_number', 'is_done_invoice', 'back_money_way', 'product_category', 'is_done_order', 'is_quantity', 'customer_nature', 'order_nos', 'oth_order_nos', 'is_done_stage', 'is_verify_rebate', 'trade']
  singleFields.forEach((field) => {
    if (data[field] != null) {
      condition[field] = data[field]
    }
  })

  if (data.orderBy) {
    condition.orderBy = data.orderBy;
  }

  return condition
}

// 搜索下拉配置
const searchSelectOptions = {
  artistOption: [],
  saleOption: [],
  executors: [],
  order_source: [],
  form_of_cooperations: [],
  productCategoriesOptions: [],
  customerNaturesOptions: [],
  boolExecOptions: [
    {label: '已执行', value: 1},
    {label: '未执行', value: 0},
  ],
  //是否挂车
  isTrailerOptions: [
    {label: '是', value: 1},
    {label: '否', value: 0},
  ],
  //是否直播
  isLbOptions: [
    {label: '是', value: 1},
    {label: '否', value: 0},
  ],
  //是否新客
  isNewCustomer: [
    {label: '是', value: 'Y'},
    {label: '否', value: "N"},
  ],
  //是否新客
  boolCovenant: [
    {label: '是', value: 1},
    {label: '否', value: 0},
  ],
  payStatusOptions: [
    {label: '已完结', value: 2},
    {label: '部分回款', value: 1},
    {label: '待回款', value: 0},
  ],
  invoiceStatusOptions: [
    {label: '未开票', value: 'none'},
    {label: '部分开票', value: 'part'},
    {label: '全部开票', value: 'done'},
  ],
  datetimeOptions: [
    {label: '下单时间', value: 'created_timestamp'},
    {label: '执行时间', value: 'exec_timestamp'},
    {label: '结款时间', value: 'payed_timestamp'},
    {label: '发布时间', value: 'release_timestamp'},
    {label: '创建时间', value: 'created_at'},
  ]
}

const searchConfigs = [
  'customer_id', 'artist_id', 'agent_name', 'time_type', 'order_source', 'activation_type', 'bool_exec', 'is_trailer',
  'is_lb', 'executor_id', 'pay_status', 'invoice_status', 'is_can_invoice', 'sale_id', 'brand', 'order_no', 'platform',
  'order_type', 'bool_undo', 'form_of_cooperations', 'contract_filed', 'contract_no', 'is_mark_invoiced', 'is_mark_rebate', 'organization_id',
  'is_new_customer', 'bool_covenant', 'invoice_number', 'is_done_invoice', 'back_money_way', 'product_category', 'is_quantity', 'customer_nature',
  'oth_order_no', 'is_verify_rebate', 'trade', 'exec_customer_id'
];

/**
 * 计算费用明细
 * @param param
 * @param isDouYinXT
 * @return {{payment_account: number, adv_revenue: number, exec_price: number, rebates_rate: *, rebates_amount: *, real_income: number, artist_income: number, company_income: number}}
 */
const calculateFee = function (param, isDouYinXT) {
  let payment_account, adv_revenue, exec_price, rebates_amount, rebates_rate, real_income, artist_income,
    company_income, place_order_money;

  // 計算：1+稅點
  const tax_point = param.tax_point || 0;
  const one_plus_tax = new BigNumber(tax_point).dividedBy(100).plus(1).toFixed(2);

  // 红人分成比例
  const artist_rebate_rate = param.rate || 0

  if (isDouYinXT) {
    // 是抖音星图
    // 1. 含税收入 = 下单金额 * 97%
    place_order_money = param.place_order_money || 0;
    payment_account = new BigNumber(place_order_money).times(0.97).toFixed(2)
  } else {
    // 其他
    place_order_money = null
    payment_account = param.payment_account || 0;
  }

  // 2. 广告收入 =（含税收入-代下单平台费-粉丝福利-投流费）/（1+税点）
  adv_revenue = new BigNumber(payment_account).minus((param.platform_fee_po || 0)).minus((param.weal_price || 0)).minus((param.invest_flow_fee || 0)).dividedBy(one_plus_tax).toFixed(2)

  // 3. 广告执行价 = 广告收入 - 直播坑位费 /（1+税点）- 线下结佣 /（1+税点）
  exec_price = new BigNumber(adv_revenue)
    .minus(new BigNumber(param.cart_commission || 0).dividedBy(one_plus_tax).toFixed(2))
    .minus(new BigNumber(param.offline_rebate || 0).dividedBy(one_plus_tax).toFixed(2))
    .toFixed(2)

  // 4. 返点金额 = 合作原价 * 返点比例——————（合作原价/广告执行价）
  const money = param.cooperative_ori_price || exec_price || 0
  if (param.rebates_handle === 'rebates_rate') {
    rebates_rate = param.rebates_rate || 0
    rebates_amount = new BigNumber(money).times(rebates_rate).dividedBy(100).toFixed(2)
  } else {
    rebates_amount = param.rebates_amount || 0
    rebates_rate = new BigNumber(rebates_amount).dividedBy(money).times(100).toFixed(2)
  }

  // 5. 实际所得 = 广告收入 - 返点金额 / 1.06
  real_income = new BigNumber(adv_revenue).minus(new BigNumber(rebates_amount).dividedBy(one_plus_tax)).toFixed(2)

  // 6. 红人分成 = 实际所得 * 分红比例
  artist_income = new BigNumber(real_income).times((artist_rebate_rate || 0)).dividedBy(100).toFixed(2)

  // 7. 公司所得 = 实际所得 - 红人分成
  company_income = new BigNumber(real_income).minus(artist_income).toFixed(2)

  return {
    payment_account,
    adv_revenue,
    exec_price,
    rebates_rate,
    rebates_amount,
    real_income,
    artist_income,
    company_income,
    place_order_money
  }
}

export {
  mTofixed,
  calculateFee,
  judgeOrderWholeCase,
  filterSearchCondition,
  searchSelectOptions,
  searchConfigs
}
